module.exports = __webpack_public_path__ + "6afa9847b97207d83ac9751e8bcba362.MP3";